module.exports = __webpack_public_path__ + "img/nuvem.c8e210f5.svg";